import { render, staticRenderFns } from "./ResourceBookingCheckout.vue?vue&type=template&id=52b8bcc0&"
import script from "./ResourceBookingCheckout.vue?vue&type=script&lang=js&"
export * from "./ResourceBookingCheckout.vue?vue&type=script&lang=js&"
import style0 from "./ResourceBookingCheckout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports